









































































































































import { Component, Vue } from "vue-property-decorator";
import AppBar from "../../components/AppBar.vue";
import Footer from "../../components/Footer.vue";

@Component({ components: { AppBar, Footer } })
export default class Adocao extends Vue {
  public created() {
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  }
}
